module.exports = __webpack_public_path__ + "static/erickson2-49870d882c1ddda52afdc5c59dbbf8de.jpg";